<template>
  <div id="footer">
    <div class="content5">
      <div class="con">
        <div class="contactInfo">
          <div class="title">{{$t("contactInfo.title")}}</div>
          <div class="conText">
            <div>{{$t("contactInfo.email")}}</div>
            <div>{{$t("contactInfo.cntel")}}</div>
            <div>{{$t("contactInfo.entel")}}</div>
            <div>{{$t("contactInfo.contact")}}</div>
            <div>{{$t("contactInfo.address")}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {

  data() {
    return {

    };
  },
  //定义这个sweiper对象
  computed: {},
  mounted() {
  },
  methods: {


  }
};
</script>
<style scoped lang="less" type="text/less">
#footer{
  .content5{
    padding: 2rem 0;
    background: #3B3D40;
    .con{
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .contactInfo,.menuInfo,.weChatInfo{
        text-align: left;
        .title{
          font-size: 2rem;
          color: #fff;
          font-weight: bold;
        }
        .conText{
          font-size: 1.2rem;
          color: #fff;
          padding: 10px 0;
          line-height: 2rem;
          &.link{
            div{
              cursor: pointer;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .footer{
    background: #505254;
    padding: 20px;
    .con{
      width: 80%;
      text-align: center;
      margin: 0 auto;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/common/footer.vue